import React,{useEffect}  from "react";
import PropTypes from "prop-types";
import { Dropdown } from "antd";

import { useSelector, useDispatch } from "react-redux";

import {
  updateUI,
  fetchDeviceTypeRequest,
  shipmentValidationRequest
} from "../../store/actions/deviceProfile";
import {
  fetchRequest as fetchLocationRequest
} from "../../store/actions/location";
import getSingleDeviceProfile from "./utility/getSingleDeviceProfile";

const DeviceProfileDropdownSingle = (props) => {
  const { name, id } = props;
  const { deviceTypes, deviceProfiles, forms,hasActiveShipments1 } = useSelector((state) => ({
    deviceTypes: state.deviceProfile.ui.form.deviceTypes,
    deviceProfiles: state.deviceProfile.data.devices,
    forms: state.deviceProfile.ui.form,
    hasActiveShipments1:state.deviceProfile.ui.shipValidate
  }));

  const dispatch = useDispatch();
  useEffect(() => {
  if (hasActiveShipments1?.proceed === true && hasActiveShipments1?.id === id) {
     editProfile(id);
    dispatch(updateUI({
      key: "shipValidate",
      value: { id: null, proceed: false }
    }));
  }
}, [hasActiveShipments1?.proceed]);

  const handleViewProfile = (id) => {
    const singleDeviceProfile = getSingleDeviceProfile(deviceProfiles, id, deviceTypes);
   
    if (singleDeviceProfile === null) return;
    dispatch(fetchDeviceTypeRequest());
    dispatch(
      updateUI({
        key: "form",
        value: {
          isOpen: true,
          type: "view",
          step: -1,
          ...singleDeviceProfile,
        },
      })
    );
  };
  const handleDeleteProfile = (id) => {
    dispatch(shipmentValidationRequest({
      id,
      actionType: "delete",
      callback: ({ hasActiveShipments }) => {
        if (hasActiveShipments) {
          dispatch(updateUI({
            key: "activeShipmentPopup",
            value: {
              isOpen: true,
              type: "deleteWarning",
              id
            }
          }));
        } else {
          deleteProfile(id);
        }
      }
    }));
  };

  const deleteProfile = (id) => {
    dispatch(
      updateUI({
        key: "delete",
        value: {
          isOpen: true,
          id,
          name,
        },
      })
    );
  };
const handleEditProfile = (id) => {
    dispatch(shipmentValidationRequest({
      id,
      actionType: "edit",
      callback: ({ hasActiveShipments }) => {
        if (hasActiveShipments) {
          dispatch(updateUI({
            key: "activeShipmentPopup",
            value: {
              isOpen: true,
              type: "editWarning",
              id
            }
          }));
        } else {
          editProfile(id);
        }
      }
    }));
  };

  const editProfile = (id) => {
    const singleDeviceProfile = getSingleDeviceProfile(deviceProfiles, id, deviceTypes);
    if (singleDeviceProfile === null) return;
    dispatch(fetchLocationRequest(-1));
    dispatch(fetchDeviceTypeRequest());
    dispatch(
      updateUI({
        key: "form",
        value: {
          ...forms,
          isOpen: true,
          type: "edit",
          step: 1,
          ...singleDeviceProfile,
          single: {
            ...singleDeviceProfile.single,
            name,
            id,
          },
          fields: {
            ...singleDeviceProfile.fields
          },
        },
      })
    );
  };

  const handleCloneProfile = (id) => {
    const singleDeviceProfile = getSingleDeviceProfile(deviceProfiles, id, deviceTypes);
    if (singleDeviceProfile === null) return;
    dispatch(fetchLocationRequest(-1));
    dispatch(fetchDeviceTypeRequest());
    dispatch(
      updateUI({
        key: "form",
        value: {
          ...forms,
           isOpen: true,
          type: "clone",
          step: 1,
          ...singleDeviceProfile,
          single: {
            ...singleDeviceProfile.single,
            name: "",
            id: "",
          },
          fields: {
            ...singleDeviceProfile.fields,
            step1: {
              ...singleDeviceProfile.fields.step1,
              profileName: {
                ...singleDeviceProfile.fields.step1.profileName,
                value: "",
              },
            },
          },
        },
      })
    );
  };

  const items = [
    {
      label: <span className="font-face-vzw">Actions</span>,
      key: `${id}-1`,
    },
    {
      label: (
        <button onClick={() => handleViewProfile(id)} className="ats-text-btn">
          View profile
        </button>
      ),
      key: `${id}-2`,
    },
    {
      label: (
        <button onClick={() => handleEditProfile(id)} className="ats-text-btn">
          Edit profile
        </button>
      ),
      key: `${id}-3`,
    },
    {
      label: (
        <button
          onClick={() => handleDeleteProfile(id)}
          className="ats-text-btn"
        >
          Delete profile
        </button>
      ),
      key: `${id}-4`,
    },
    {
      label: (
        <button onClick={() => handleCloneProfile(id)} className="ats-text-btn">
          Clone profile
        </button>
      ),
      key: `${id}-5`,
    },
  ];

  return (
    <Dropdown
      key={`dropdown-${id}`}
      menu={{
        items,
      }}
      trigger={["click"]}
      overlayClassName="shipment-dropdown-overlay"
    >
      <button className="btn btn-link text-secondary">
        <i className="bi-three-dots-vertical fs-6" />
      </button>
    </Dropdown>
  );
};

DeviceProfileDropdownSingle.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};

export default DeviceProfileDropdownSingle;
